import { DirectoriesProps } from "./types";
import DocumentsButtons from "../ui/documents-buttons";
import { ModalProvider } from "../../contexts/modal/index.context";
import { SessionProvider } from "../../contexts/session/index.context";
import { SignModalProvider } from "../../contexts/sign-modal/index.context";
import Table from "../ui/table";
import styles from "./styles.module.scss";

//Components



export default function Directories(props: DirectoriesProps) {
  // console.log("DIRECTORIES ID ", props);
  
  return (
    <ModalProvider>
      <SignModalProvider>
        <SessionProvider url={props.url}>
          <DocumentsButtons url={props.url} form={props.form} id={props.id} />
          <Table
            directories={true}
            url={props.url}
            name={props.name}
            id={props.id}
            selectedRowId={props.selectedRowId}
            selectedRowsId={props.selectedRowsId}
            activeModal={props.activeModal}
            form={props.form}
            tableData={props.tableData}
            type={props.type}
            allowMultiSelect={props.allowMultiSelect}
          />
        </SessionProvider>
      </SignModalProvider>
    </ModalProvider>
  );
}
